import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Divider,
  Chip,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon, Visibility as VisibilityIcon } from '@mui/icons-material';
import ModernButton from '../common/ModernButton';

const DetailRow = ({ label, value, chip, chipColor }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
    <Typography variant="body2" color="text.secondary">{label}</Typography>
    {chip ? (
      <Chip label={value} size="small" color={chipColor || 'default'} />
    ) : (
      <Typography variant="body2" fontWeight={500}>
        {value || '-'}
      </Typography>
    )}
  </Box>
);

const ViewDetailsDialog = ({
  open,
  onClose,
  title = 'Details',
  data,
  fields,
  icon = <VisibilityIcon />,
  actions,
  maxWidth = 'sm',
}) => {
  if (!data) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3 }
      }}
    >
      <DialogTitle sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        pb: 1
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ color: 'primary.main', display: 'flex' }}>
            {icon}
          </Box>
          {title}
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 2 }}>
        {fields.map((field, index) => {
          if (field.divider) {
            return <Divider key={index} sx={{ my: 1 }} />;
          }

          if (field.section) {
            return (
              <Typography
                key={index}
                variant="subtitle2"
                color="primary"
                sx={{ mt: 2, mb: 1 }}
              >
                {field.section}
              </Typography>
            );
          }

          const value = typeof field.render === 'function'
            ? field.render(data)
            : data[field.key];

          return (
            <DetailRow
              key={field.key || index}
              label={field.label}
              value={value}
              chip={field.chip}
              chipColor={field.chipColor?.(data)}
            />
          );
        })}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        {actions || (
          <ModernButton variant="outlined" onClick={onClose}>
            Close
          </ModernButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ViewDetailsDialog;
export { DetailRow };
